import { BACKEND_ERROR_TRANSLATOIN_KEY } from "constants/backendError";

const IGNORED_MESSAGES = ["unexpected error"];

export const getBackendErrorMessage = (error: any, customMessage: string) => {
  if (
    error?.data?.message &&
    !IGNORED_MESSAGES.includes(error.data.message.toLowerCase())
  ) {
    if (BACKEND_ERROR_TRANSLATOIN_KEY?.[error.data.message.toLowerCase()]) {
      return {
        requiredTranslate: true,
        errorMessage:
          BACKEND_ERROR_TRANSLATOIN_KEY[error.data.message.toLowerCase()],
      };
    }

    return {
      requiredTranslate: false,
      errorMessage: error?.data?.message as string,
    };
  }

  return {
    requiredTranslate: false,
    errorMessage: customMessage,
  };
};
